import React, { Component } from 'react';
import Article from './Article';

class ArticleList extends Component {
  render(props) {
    return (
      <section className="articles">
        <div className="column is-8 is-offset-2">
          {this.props.articles.map(a => <Article article={a} />)}
        </div>
      </section>
    );
  }
}

export default ArticleList;



// WEBPACK FOOTER //
// ./src/components/articles/ArticleList.jsx